import httpClient from "@lab/api/httpClient";

export default {
	fetch: async () => {
		const response = await httpClient.get(`/organisations`);
		return response.data;
	}
};
